module.exports = __webpack_public_path__ + "img/ask_the_ergonomist.b1bca28a.png";